import styled from "styled-components";
import Text from "./Text";

export const S = styled(Text)`
    font-family: ${(props) => props.theme.font.s["font-family"]};
    font-style: ${(props) => props.theme.font.s["font-style"]};
    font-weight: ${(props) => props.theme.font.s["font-weight"]};
    font-size: ${(props) => props.theme.font.s["font-size"]};
    line-height: ${(props) => props.theme.font.s["line-height"]};
`;

export default S;
